import styles from 'styles/shop/product.module.css';
import { Clickable } from 'phoenix-components';
import cx from 'classnames';
import { shareIcon } from 'components/shared/Icons/Product';
import React from 'react';
import { getCurrency } from 'ui/utils';
import { shareProduct } from 'components/utils/share';
import { shareText } from 'ui/lib/share';
import { useLanguageLoader } from 'contexts/language';
import { useIsCustomDomain } from 'contexts/profile';
import { useSelectedVariant } from 'components/products/hooks';
import { useProduct, useShop } from 'components/products/context';
import { get } from 'ui/lodash';

export function Share() {
  const lang = useLanguageLoader();
  const shop = useShop();
  const product = useProduct();
  const showBanner = !get(shop, 'featureConfig.banner', true);
  const isCustomDomain = useIsCustomDomain();
  const selectedVariant = useSelectedVariant();

  const share = () => {
    const text = `${lang('store.words.hello')}!

${lang('store.alerts.iFoundThis')} ${shop?.name}.
${lang('store.words.productName')} - *${product?.title}*
${lang('store.words.price')} - *${getCurrency(selectedVariant?.discountedAmount, shop?.currency)}*
${lang('store.alerts.checkOutHere')}
${shareProduct(shop?.slug || 'shop', product.slug, isCustomDomain)}

${shop?.name}
${showBanner ? 'Created with ❤️ on WINDO' : ''}
`;
    shareText(text, shareProduct(shop?.slug || 'shop', product.slug, isCustomDomain));
  };

  return (
    <div className={styles.shareIcon}>
      <Clickable
        className={cx(styles.share)}
        onClick={share}
      >
        {shareIcon()}
      </Clickable>
    </div>
  );
}
